import Customers from './views/Customers'
import Customer from './views/Customer'
import Groups from './views/Groups'
import Group from './views/Group'

export default { 
    routes: [
        {
            path: '/customers',
            name: 'Customers',
            components: { default: Customers },
            meta: {tab: 'customers', toolbars: ['Search']}
        },
        {
            path: '/customers/:customer_id',
            name: 'Customer',
            components: { default: Customers, right: Customer },
            meta: {tab: 'customers', toolbars: ['Search']}
        },
        {
          path: '/customers/groups',
          name: 'CustomerGroups',
          component: Groups,
          meta: {tab: 'groups'}
        },
        {
          path: '/customers/groups/:groupid',
          name: 'CustomerGroup',
          components: {right: Group, default: Groups},
          meta: {tab: 'groups'}
        },
        
    ]  
}


// WEBPACK FOOTER //
// ./src/modules/customers/routes.js